import { getQuestPackImageSrc } from '../utils/questPackImages';

export const getPackId = (pack) => pack?.id ?? pack?.pack ?? '';
export const getPackName = (pack) => pack?.name ?? pack?.pack_name ?? pack?.slug ?? '';
export const getPackDescription = (pack) => pack?.description ?? '';
export const getPackImage = (pack) => getQuestPackImageSrc(pack?.pack_image);
export const formatStorePrice = (value) => {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return '';
  }

  return `$${numericValue.toFixed(2)}`;
};

export const formatCompactStorePrice = (value) => {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return '';
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: Number.isInteger(numericValue) ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(numericValue);
};

export const formatCreditCost = (value) => {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue) || numericValue < 0) {
    return '';
  }

  const roundedValue = Math.round(numericValue);
  const creditLabel = roundedValue === 1 ? 'Credit' : 'Credits';

  return `${roundedValue} ${creditLabel} to Play`;
};

export const formatPlayStyle = (value) => {
  const normalized = String(value || '').trim().toLowerCase();

  if (normalized === 'solo') {
    return 'Solo';
  }

  if (normalized === 'group_solo') {
    return 'Group or Solo';
  }

  return 'Group';
};

export const findPackById = (packs = [], selectedId) =>
  (packs || []).find((pack) => getPackId(pack) === selectedId);

export const getVisibleGamePacksForSetup = (packs = [], { embedded = false } = {}) =>
  (packs || []).filter((pack) => embedded || !pack?.admin_only);
